export default {
    dateOfIEP:'IEP date',
    year:'Year',
    numberOfGoals:'Goals',
    numberOfObjectives:'Objectives',
    numberOfObjectivesAchieved:'Completed Objectives'

}
